// Port of api/fuel/app/classes/filter/package/games/game/package/context.php
export default {
	run: function(pkg, local) {
		if (!local.context || !local.context.plays) return pkg
		pkg.context = { user: local.context.plays.user || {}, users: local.context.plays.users || {} }
		return pkg
	}
}
